import { MessageDescriptor } from 'react-intl';
import { CategorizedHotkeys, CategoryInput, HotkeysDefinitionMap } from './hotkeys.types';

/** Translate function (e.g. $t from useIntl) for message descriptors. */
export type TranslateMessage = (descriptor: MessageDescriptor) => string;

/**
 * Transforms a hotkeys config (categories keyed by id) into CategorizedHotkeys with translated labels.
 * Category order follows the key order in the given record. Use for HotkeysDialog and similar UIs.
 */
export function categorizeHotkeys(
  hotkeysConfig: Record<string, CategoryInput>,
  t: TranslateMessage,
): CategorizedHotkeys {
  return Object.entries(hotkeysConfig).map(([categoryId, category]) => {
    const hotkeys = Object.fromEntries(
      Object.entries(category.hotkeys).map(([id, def]) => [
        id,
        { key: def.key, label: t(def.label) },
      ]),
    ) as HotkeysDefinitionMap;

    const categoryLabel = category.label ? t(category.label) : categoryId;

    return {
      categoryLabel,
      hotkeys,
    };
  });
}
